'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');
var Radio = require('../../Radio/Radio.js');
var RadioGroup = require('../../RadioGroup/RadioGroup.js');
var Input = require('../../Input/Input.js');
var Button = require('../../Button/Button.js');
var Login = require('../Login.js');
require('./KYCform.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var KYCform = function () {
    var _a = React.useState(false), isPassport = _a[0], setIsPassport = _a[1];
    var _b = Login.useLoginContext(), errorMessage = _b.errorMessage, handleIDverification = _b.handleIDverification;
    var handleSubmit = function (e) {
        e.preventDefault();
        var _a = e.target, ktp = _a.ktp, passport = _a.passport, annualIncome = _a.annualIncome, sourceOfFund = _a.sourceOfFund;
        var payload = {
            ktp: ktp ? ktp.value : "",
            passport: passport ? passport.value : "",
            annualIncome: annualIncome.value,
            sourceOfFund: sourceOfFund.value
        };
        handleIDverification(payload);
    };
    return (React__default['default'].createElement("div", { className: 'kyc__background' },
        React__default['default'].createElement("div", { className: 'kyc__box' },
            React__default['default'].createElement("p", null, "Verifikasi ID"),
            React__default['default'].createElement(RadioGroup.RadioGroup, { id: "radio__group__wrap", groupAlignment: 'horizontal' },
                React__default['default'].createElement(Radio.Radio, { id: "id_type", name: "id_type", labelName: 'KTP', value: "KTP", isChecked: !isPassport, handleOnChange: function () { return setIsPassport(false); } }),
                React__default['default'].createElement(Radio.Radio, { id: "id_type", name: "id_type", labelName: 'Passport', value: "Passport", isChecked: isPassport, handleOnChange: function () { return setIsPassport(true); } })),
            React__default['default'].createElement("form", { onSubmit: handleSubmit },
                React__default['default'].createElement(Input.Input, { name: isPassport ? "passport" : "ktp", type: "numeric", inputMode: 'numeric', placeholder: isPassport ? "No.Passport" : "No. KTP", maxLength: 16, onChange: function () { }, size: "md", error: errorMessage && (errorMessage.passport || errorMessage.ktp) }),
                React__default['default'].createElement(Input.Input, { name: "annualIncome", type: "numeric", inputMode: 'numeric', isCurrency: true, placeholder: "Pendapatan Dalam Setahun", onChange: function () { }, size: "md", error: errorMessage && errorMessage.annualIncome }),
                React__default['default'].createElement(Input.Input, { name: "sourceOfFund", type: "text", inputMode: 'text', placeholder: "Sumber Pendapatan", onChange: function () { }, size: "md", error: errorMessage && errorMessage.sourceOfFund }),
                React__default['default'].createElement(Button.Button, { variant: 'primary', id: 'regis-btn', type: 'submit', isBlock: true, className: 'action-button bottom-16p', onClick: function () { } }, "Simpan")))));
};

module.exports = KYCform;
//# sourceMappingURL=KYCform.js.map
